import React from "react";
import { motion, useTransform, useScroll } from "framer-motion";
import MaleUser from '../../assets/team/MaleUser.png';
import FemaleUser from '../../assets/team/FemaleUser.png';
import RitikSinghImg from '../../assets/team/Ritik_Singh.jpg';

const teamMembers = [
    { 
        id: 0, 
        name: 'Ritik Singh', 
        role: 'Website Developer', 
        imageUrl: RitikSinghImg,
        link: 'https://wa.me/917217729644?text=Hi Ritik, I saw your work on Aanya Homes and I am interested in your web development services.'
    },
    { id: 1, name: 'Kashak', role: 'H.R, Marketing', imageUrl: FemaleUser },
    { id: 2, name: 'Harpreet Singh', role: 'Sales Manager', imageUrl: FemaleUser },
    { id: 3, name: 'Mohit', role: 'Team Lead', imageUrl: MaleUser },
    { id: 4, name: 'Rohit', role: 'Team Lead', imageUrl: MaleUser },
    { id: 5, name: 'Abhishek', role: 'Team Lead', imageUrl: MaleUser },
    { id: 6, name: 'Komal', role: 'Sales', imageUrl: FemaleUser },
    { id: 7, name: 'Prashant', role: 'Sales', imageUrl: MaleUser },
    { id: 8, name: 'Rohit Kumar', role: 'Sales', imageUrl: MaleUser },
    { id: 9, name: 'Anshu', role: 'Sales', imageUrl: MaleUser },
    { id: 10, name: 'Ayush', role: 'Sales', imageUrl: MaleUser },
    { id: 11, name: 'Bhawna', role: 'Sales', imageUrl: FemaleUser },
    { id: 12, name: 'Mehak', role: 'Sales', imageUrl: FemaleUser }
];

export const Teams = () => {
    const targetRef = React.useRef(null);
    const { scrollYProgress } = useScroll({ target: targetRef });
    const x = useTransform(scrollYProgress, [0, 1], ["1%", "-95%"]);

    return (
        <div className="bg-neutral-800">
            <div className="flex h-48 items-center justify-center font-semibold uppercase text-white">Scroll down 👇</div>
            <section ref={targetRef} className="relative h-[300vh] bg-neutral-900">
                <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                    <motion.div style={{ x }} className="flex items-center gap-4">
                        <h2 className="font-semibold text-2xl text-center lg:text-3xl text-white">Meet Our Team</h2>
                        {teamMembers.map(member => <TeamMember key={member.id} {...member} />)}
                        <p className="w-60 h-60 flex items-center justify-center font-bold text-lg md:text-xl bg-pink-800 text-white text-center rounded-full relative">
                            +49 Sales Executives
                        </p>
                    </motion.div>
                </div>
            </section>
            <div className="flex items-center justify-center font-semibold uppercase text-white">Scroll up 👆</div>
        </div>
    );
};

const TeamMember = ({ name, role, imageUrl, link }) => {
    const CardContent = (
        <div className="flex flex-col items-center justify-center gap-4 rounded-md group relative h-[300px] w-[270px] overflow-hidden bg-white shadow-xl transition-all duration-300">
            <div className="relative w-48 h-48 rounded-full overflow-hidden shadow-md">
                <img src={imageUrl} alt={name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                {link && (
                    <div className="absolute inset-0 bg-blue-600/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                        <span className="bg-white text-blue-600 text-[10px] font-bold px-3 py-1 rounded-full shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform">
                            HIRE ME
                        </span>
                    </div>
                )}
            </div>
            <div className="text-center text-white">
                <p className="font-semibold text-lg bg-white text-black">{name}</p>
                <p className="text-[13px]">{role}</p>
            </div>
        </div>
    );

    if (link) {
        return (
            <motion.a 
                whileHover={{ y: -10 }}
                whileTap={{ scale: 0.95 }}
                href={link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="cursor-pointer"
            >
                {CardContent}
            </motion.a>
        );
    }

    return CardContent;
};